import { useIsMounted } from "./useIsMounted";
import { useState } from "react";
export const useIsReady = (isReady, onIsReady) => {
    const isMountedRef = useIsMounted();
    const [hasFiredOnIsReady, setHasFiredOnIsReady] = useState(false);
    if (isReady && !hasFiredOnIsReady) {
        if (isMountedRef.current) {
            setHasFiredOnIsReady(true);
            onIsReady();
        }
    }
};
